/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum InfusionTerminateAliases {
  DISCARDED_VOLUME_FIELD = 'discarded-volume-field',
  DISCARDED_VOLUME_INPUT = 'discarded-volume-input',
  DISCARDED_VOLUME_UNIT = 'discarded-volume-unit',
  DT_CURRENT_TIME = 'dt-current-time ',
  DT_CURRENT_TIME_INPUT = 'dt-current-time-input',
  FETCH_INFUSION = 'fetch-infusion',
  FORM_INFUSION_TERMINATE = 'form-infusion-terminate',
  INFORMATION_BAR_HEADER_FRAGMENT = 'information-bar-header-fragment',
  INFUSED_VOLUME_FIELD = 'infused-volume-field',
  INFUSED_VOLUME_INPUT = 'infused-volume-input',
  INFUSED_VOLUME_UNIT = 'infused-volume-unit',
  INFUSION_HEADER_GRAGMENT = 'infusion-header-gragment',
  INFUSION_TERMINATE_CONTEXTUAL_BAR = 'infusion-terminate-contextual-bar',
  LAYOUT_INFUSION_CONTENT = 'layout-infusion-content',
  LAYOUT_INFUSION_TERMINATE = 'layout-infusion-terminate',
  OBSERVATION_FIELD = 'observation-field',
  OBSERVATION_TEXT_AREA = 'observation-text-area',
  PANEL_INFUSIONS_VIEWER_CONTENT = 'panel-infusions-viewer-content',
  PARTIAL_VOLUME_FIELD = 'partial-volume-field',
  PARTIAL_VOLUME_TEXT = 'partial-volume-text',
  VOLUME_STEP_FIELD = 'volume-step-field',
  VOLUME_STEP_TEXT = 'volume-step-text',
}
export { InfusionTerminateAliases };
